<template>
  <el-form
    :model="formData"
    :rules="rules"
    ref="formRef">
    <el-form-item label="收取金额上限" prop="planAmount">
      <el-input
        v-model="formData.planAmount"
        v-number:money="{
          isHideErr: true,
        }">
          <template slot="append">元</template>
        </el-input>
    </el-form-item>
  </el-form>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import { PAY_MODE } from '@/config/rentConfig'

const props = defineProps({
  configData: {
    type: Object,
    default: () => ({}),
  },
})
const formRef = ref(null)
const formData = ref({
  planAmount: '',
})
const rules = {
  planAmount: [
    {
      required: true,
      message: '请输入收取金额上限',
      trigger: 'blur',
    },
  ],
}
const getFormData = async () => {
  try {
    const valid = await formRef.value.validate()
    return {
      ...formData.value,
      fundType: props.configData.fundType,
      payMode: PAY_MODE.POSTPAID_ITEM,
      payModeText: '后置费项收款',
      totalAmount: formData.value.planAmount,
      amount: formData.value.planAmount,
    }
  } catch {
    return false
  }
}
onMounted(() => {
  formData.value.planAmount = props.configData.formData.planAmount
})
defineExpose({
  getFormData,
})
</script>
<style lang="scss" scoped>
::v-deep .el-form-item .el-form-item__label {
  justify-content: flex-start;
}
</style>
